import InteriorDesign from "../../components/public/userInterior/InteriorDesign";
import DreamInteriorDesign from "../../components/public/userInterior/DreamInteriorDesign";
import InteriorBanner from "../../components/public/userInterior/InteriorBanner";

const Interior = () => {
  return (
    <div className="overflow-hidden">
      <InteriorBanner />
      <InteriorDesign />
      <DreamInteriorDesign />
      <div>
        <InteriorDesign />
      </div>
    </div>
  );
};

export default Interior;
